var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 18 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M17 11L1 21V1l16 10z","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }